<template>
  <!-- 按钮背景
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="按钮背景"> 
      <el-radio-group v-model="buttonBack" size="small">
        <el-radio-button :label="false">无</el-radio-button>
        <el-radio-button :label="true">是</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 按钮背景
     *  @description 将 buttonBack 字段映射到当前 buttonBack 计算属性
     *  @return { Boolean }
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      buttonBack: { 
        parent: i => i.baseOption,
        attr: "buttonBack" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingButtonBack.vue